import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Address from "./components/account/Address";
import Dashboard from "./components/account/Dashboard";
import Login from "./components/account/Login";
import Orders from "./components/account/Orders";
import Cart from "./components/cart/Cart";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import Shop from "./components/shop/Shop";
import Welcome from "./components/account/Welcome";
function App() {
  let [cart, setCart] = useState({ items: [], qty: 0 });
  const [details, setDetails] = useState([]);

  const addToCart = (product) => {
    let tempCart = [...cart.items];
    let existing_item = tempCart.find((p) => p.id === product.id);
    if (existing_item) existing_item.qty += 1;
    else {
      tempCart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        img: product.img,
        qty: 1,
      });
    }

    setCart({ items: tempCart, qty: cart.qty + 1 });
    let stringCart = JSON.stringify(tempCart);
    localStorage.setItem("cart", stringCart);
  };
  const removeFromCart = (product) => {
    let tempCart = [...cart.items];
    let existing_item = tempCart.find((p) => p.id === product.id);
    if (existing_item) {
      existing_item.qty -= 1;
      if (existing_item.qty === 0) {
        tempCart.splice(tempCart.indexOf(existing_item), 1);
      }
    }
    setCart({ items: tempCart, qty: cart.qty - 1 });
    let stringCart = JSON.stringify(tempCart);
    localStorage.setItem("cart", stringCart);
  };
  const emptyCart = (product) => {
    let tempCart = [...cart.items];
    let existing_item = tempCart.find((p) => p.id === product.id);
    if (existing_item) {
      tempCart.splice(tempCart.indexOf(existing_item), 1);
    }
    setCart({ items: tempCart, qty: cart.qty - existing_item.qty });
    let stringCart = JSON.stringify(tempCart);
    localStorage.setItem("cart", stringCart);
  };
  useEffect(() => {
    let tempQty = 0;
    let localCart = localStorage.getItem("cart");
    localCart = JSON.parse(localCart);
    if (localCart) {
      localCart.forEach((item) => {
        tempQty += item.qty;
      });
    }
    if (localCart) setCart({ items: localCart, qty: tempQty });
  }, []);

  return (
    <Router style={{ userSelect: "none" }}>
      <Header cartQty={cart.qty} />
      <Switch>
        <Route path="/shop">
          <Shop
            addToCart={addToCart}
            removeFromCart={removeFromCart}
            cart={cart}
          />
        </Route>

        <Route path="/" exact>
          <Home
            addToCart={addToCart}
            cart={cart}
            removeFromCart={removeFromCart}
          />
        </Route>

        <Route path="/cart" exact>
          <Cart
            addToCart={addToCart}
            cart={cart}
            setCart={setCart}
            removeFromCart={removeFromCart}
            emptyCart={emptyCart}
            details={details}
          />
        </Route>

        <Route path="/login" exact>
          <Login />
        </Route>

        <Route path="/dashboard" exact>
          <Dashboard>
            <Welcome />
          </Dashboard>
        </Route>
        <Route path="/dashboard/orders" exact>
          <Dashboard>
            <Orders />
          </Dashboard>
        </Route>
        <Route path="/dashboard/address" exact>
          <Dashboard>
            <Address details={details} setDetails={setDetails} />
          </Dashboard>
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
